import { Cookies } from 'react-cookie';

import axiosInterceptor from 'api/interceptor/axiosClient';
import { TrapType } from 'components/AnalyticsPage/TrapType';
import { ChartSignal } from 'api/traps/types';

export const getAnalyticsHeatMapChart = async (
  slug: string,
  trapType: TrapType,
  start_datetime: string,
  end_datetime: string,
) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`api/v1/traps/activation-signals/object/${slug}/`, {
    headers: {
      Authorization: token,
    },
    params: {
      type: trapType,
      start_datetime: start_datetime,
      end_datetime: end_datetime,
    },
  });
  return data.data as ChartSignal[];
};
